<template>
  <BasePanel :title="$t(noLicensing ? 'fetchMyRecord.nonLicensing.title' : 'fetchMyRecord.title')">
    <template #container-header>
      <b-container v-if="!noLicensing && getCityLetterLogoURL" class="mb-4" fluid>
        <b-img center class="city-logo-img" :src="getCityLetterLogoURL" :alt="getImageAltText || getCityOrganization || ''" fluid />
      </b-container>
    </template>

    <template #info>
      <p v-if="noLicensing" class="text-dark">
        {{ $t('fetchMyRecord.nonLicensing.subheading') }}
      </p>
      <BaseDisplayMessage
        v-else-if="getCityOrganization"
        class="text-dark"
        :no-path-translation="false"
        :message="{
          path: 'fetchMyRecord.subheading',
          getCityOrganization: getCityOrganization,
          action: {
            text: $t('fetchMyRecord.actionText.signUpHere'),
            to: { name: 'SyfSignUp' },
          },
        }"
      />
    </template>

    <slot name="errors" />

    <b-tabs content-class="mt-3" nav-class="flex-nowrap text-center align-items-stretch">
      <b-tab
        :button-id="'tab-by-access-code'"
        :active="currentScreen == 'ByAccessCode'"
        title-item-class="font-weight-bold w-50"
        title-link-class="h-100 d-flex align-items-center"
        :title-link-attributes="{ to: { name: 'FetchMyRecordByAccessCode' }, activeClass: 'text-dark' }"
      >
        <template #title>
          <span class="text-decoration-none w-100"> {{ 'fetchMyRecord.byAccessCode.title' | translate }} </span>
        </template>
        <ValidationObserver>
          <slot v-if="currentScreen == 'ByAccessCode'" />
        </ValidationObserver>
      </b-tab>
      <b-tab
        :button-id="'tab-by-tag-number'"
        :active="currentScreen == 'ByTagNumber'"
        title-item-class="font-weight-bold w-50"
        title-link-class="h-100 d-flex align-items-center"
        :title-link-attributes="{ to: { name: 'FetchMyRecordByTagNumber' }, activeClass: 'text-dark' }"
      >
        <template #title>
          <span class="text-decoration-none w-100"> {{ 'fetchMyRecord.byTagNumber.title' | translate }} </span>
        </template>
        <ValidationObserver>
          <slot v-if="currentScreen == 'ByTagNumber'" />
        </ValidationObserver>
      </b-tab>
    </b-tabs>

    <template #footerMessage>
      <slot name="footerMessage" />
    </template>

    <template #footer>
      <slot name="footer" />
    </template>

    <b-modal
      id="modal-how-we-source-existing-records-info"
      :title="$t('requestAccessCode.modal.title')"
      ok-only
      ok-variant="outline-primary"
      :ok-title="$t('dp.navbar.toggle.close')">
      <strong>{{ $t('requestAccessCode.modal.sectionWhyTitle') }}</strong>
      <p>
        {{ $t('requestAccessCode.modal.sectionWhyDescription', { cityOrganization: getCityOrganization}) }}
      </p>
      <strong>{{ $t('requestAccessCode.modal.sectionAccessCodeTitle') }}</strong>
      <p>
        {{ $t('requestAccessCode.modal.sectionAccessCodeDescription') }}
      </p>
      <strong>{{ $t('requestAccessCode.modal.sectionMatchingTitle') }}</strong>
      <p>
        {{ $t('requestAccessCode.modal.sectionMatchingDescription', {cityOrganization: getCityOrganization}) }}
      </p>
      <strong>{{ $t('requestAccessCode.modal.sectionAccountTitle') }}</strong>
      <p>{{ $t('requestAccessCode.modal.sectionAccountDescription') }}</p>
    </b-modal>
  </BasePanel>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'BaseFetchMyRecord',
  props: {
    currentScreen: {
      type: String,
      default: 'ByAccessCode',
    },
  },
  computed: {
    ...mapGetters('city', ['getCityLetterLogoURL', 'getCityOrganization', 'getImageAltText', 'noLicensing']),
  },
  created: function () {
    this.fetchCity();
    this.$store.commit('fetchMyRecord/RESET_ERROR');
  },
  methods: {
    ...mapActions('city', ['fetchCity']),
    screenChanged: function (screenName) {
      this.$router.push({ name: `FetchMyRecord${screenName}`, query: this.$router.currentRoute.query });
    },
  },
};
</script>

<style lang="scss" scoped>
.city-logo-img {
  max-height: 180px;
  width: auto;
}
</style>
